import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // ✅ ADDED
import { useCart } from "../../context/CartContext";
import CartItem from "../../components/cart/CartItem";
import { getProductImages } from "../../services/imageApi";
import ShopHeader from "../user/ShopHeader";
import "./cart.css";

const CartPage = () => {
  const { cartItems } = useCart();
  const navigate = useNavigate(); // ✅ ADDED

  const [imagesMap, setImagesMap] = useState({});

  const loadImages = async (items) => {
    const map = {};

    for (let item of items) {
      try {
        const imgs = await getProductImages(item.product_id);
        map[item.product_id] = imgs;
      } catch {
        map[item.product_id] = [];
      }
    }

    setImagesMap(map);
  };

  useEffect(() => {
    if (cartItems.length > 0) {
      loadImages(cartItems);
    }
  }, [cartItems]);

  const total = cartItems.reduce(
    (sum, item) => sum + (item.price || 0) * (item.quantity || 0),
    0
  );

  return (
    <div className="cart-page">

      {/* HEADER */}
      <ShopHeader
        categories={[]}
        selectedCategory="All"
        onCategoryClick={() => {}}
      />

      <div className="cart-container">

        {/* LEFT SIDE */}
        <div className="cart-items">

          <h2 className="cart-title">Shopping Cart</h2>

          {cartItems.length === 0 ? (
            <div className="empty-cart">
              <h3>Your cart is empty</h3>
              <p>Add some products to continue shopping</p>
            </div>
          ) : (
            cartItems.map((item) => (
              <CartItem
                key={item.id || item.product_id}
                item={item}
                image={imagesMap[item.product_id]?.[0]?.image_url}
              />
            ))
          )}

        </div>

        {/* RIGHT SIDE */}
        {cartItems.length > 0 && (
          <div className="cart-summary">

            <h3>Order Summary</h3>

            <div className="summary-row">
              <span>Items</span>
              <span>{cartItems.length}</span>
            </div>

            <div className="summary-row">
              <span>Total</span>
              <span>₹{total.toFixed(2)}</span>
            </div>

            {/* ✅ FIXED CHECKOUT ACTION */}
            <button
              className="checkout-btn"
              onClick={() => {
                if (cartItems.length === 0) return;
                navigate("/checkout");
              }}
            >
              Proceed to Checkout
            </button>

          </div>
        )}

      </div>
    </div>
  );
};

export default CartPage;